import { render, staticRenderFns } from "./DataTableScroll.vue?vue&type=template&id=bb9ac82c&scoped=true"
import script from "./DataTableScroll.vue?vue&type=script&lang=js"
export * from "./DataTableScroll.vue?vue&type=script&lang=js"
import style0 from "./DataTableScroll.vue?vue&type=style&index=0&id=bb9ac82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9ac82c",
  null
  
)

export default component.exports